import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseurlService } from './baseurl.service';

@Injectable({
  providedIn: 'root'
})
export class InflabService {

  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
  ) { }

  login(nr: number) {
    return this.http.post<string>(`${this.baseurlService.getBaseUrl()}/inflab/login/${nr}`, null);
  }
}
